import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var Brand = function Brand(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$src = _a.src,
      src = _a$src === void 0 ? '' : _a$src,
      alt = _a.alt,
      props = __rest(_a, ["className", "src", "alt"]);

  return (
    /** the brand component currently contains no styling the 'pf-c-brand' string will be used for the className */
    React.createElement("img", Object.assign({}, props, {
      className: css('pf-c-brand', className),
      src: src,
      alt: alt
    }))
  );
};
Brand.displayName = 'Brand';